import { useMemo } from 'react';
import { RowWithId } from '@/components/table/types/RowWithId.ts';
import { useTableStoreContext } from '@/components/table/contexts/TableContext.tsx';

/**
 * The full row objects for the current selection, resolved purely by id from
 * the table store. Because the store accumulates selected rows as they are
 * picked (see `syncSelectedRows`), this is stable across page changes and does
 * not depend on which pages are currently in the React Query cache.
 */
export function useSelectedRows<T extends RowWithId>(): T[] {
  const selectedRowsById = useTableStoreContext(
    (state) => state.selectedRowsById,
  );
  const rowSelection = useTableStoreContext((state) => state.rowSelection);

  return useMemo(
    () =>
      Object.keys(rowSelection)
        .filter((id) => rowSelection[id])
        .map((id) => selectedRowsById[id])
        .filter(Boolean) as T[],
    [selectedRowsById, rowSelection],
  );
}
